<template>
    <div class="home-wrapper">
        <panel-header></panel-header>

        <router-view></router-view>
    </div>
</template>

<script>
    import Helpers from "../../mixins/Helpers";
    import PanelHeader from "./comps/Header.vue";

    export default {
        components: {
            PanelHeader
        },

        name: "ModeratorIndex",
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/moderators/Index.vue